import { createContext } from "react";

import { initialAgenticAiState } from "./agenticAiState";
import type { AgenticAiContextType } from "./types";

export const initialAgenticAiContext: AgenticAiContextType = {
  ...initialAgenticAiState,
  openChat: () => {},
  closeChat: () => {},
  toggleOpenChat: () => {},
  sendUserPrompt: () => {},
  registerContext: () => () => {},
  registerTool: () => () => {},
  getFrontendToolByName: () => undefined,
  getAllFrontendTools: () => [],
  registerLiquidField: () => {},
  unregisterLiquidField: () => {},
  clearAllLiquidFields: () => {},
  getAllLiquidFields: () => [],
  newSession: () => {},
  clearSupportEntryPoint: () => {},
};

export const AgenticAiContext = createContext<AgenticAiContextType>(initialAgenticAiContext);
